<img
  [src]="imageUrl()"
  [style]="style"
  [alt]="alt"
  onerror="this.style.opacity=0"
  onload="this.style.opacity=1"
/>
